import { render } from "./PayModalSectionPaymentInfo.vue?vue&type=template&id=1fa64090"
import script from "./PayModalSectionPaymentInfo.vue?vue&type=script&lang=js"
export * from "./PayModalSectionPaymentInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__